export default __webpack_public_path__ + "static/media/rubik-v12-latin-regular.581c4834.woff";